import { apiClient } from './client'
import { getTelegramUserId } from '../utils/telegram'
import type { NotificationsResponse } from '../types/notification'

export const notificationsApi = {
  unreadCount: () =>
    apiClient.get<{ unread_count: number }>('/api/user/notifications/unread-count', {
      chat_id: getTelegramUserId(),
    }),

  list: (lang: 'zh' | 'en') =>
    apiClient.get<NotificationsResponse>('/api/user/notifications', {
      chat_id: getTelegramUserId(),
      lang,
    }),

  markRead: (notificationId: string) =>
    apiClient.post<NotificationsResponse>(
      `/api/user/notifications/${encodeURIComponent(notificationId)}/read?chat_id=${encodeURIComponent(getTelegramUserId())}`,
      {},
    ),

  markAllRead: () =>
    apiClient.post<NotificationsResponse>(
      `/api/user/notifications/read-all?chat_id=${encodeURIComponent(getTelegramUserId())}`,
      {},
    ),
}
